/**
 * Etiquetas de cara al usuario para los valores que guarda la base.
 *
 * El género se almacena en inglés (`female`, `trans`...) y se pintaba tal cual
 * en las tarjetas y en el perfil, así que el visitante leía "Female" en una
 * página que está entera en español. Un `text-transform: capitalize` lo
 * disimulaba a medias y de paso escribía "25 Años".
 */
export const GENDER_LABELS = {
  female: 'Mujer',
  male: 'Hombre',
  trans: 'Trans',
  other: 'Otro',
};

export const genderLabel = (gender) => GENDER_LABELS[gender] ?? gender ?? '';
